<mbs-steps [formGroup]="form">
  <mbs-step
    [number]="1"
    [readOnly]="true"
    [isSimple]="true">
    <ng-container body>
      <div class="d-flex align-items-end justify-content-between">
        <div
          class="mr-2"
          [ngClass]="{ 'text-disabled': step !== ReserveAuthSteps.SendPhoneCode }">
          <div
            class="fw-bold mbs-form_label"
            [ngClass]="{ 'text-disabled': step !== ReserveAuthSteps.SendPhoneCode }">
            SMS verification
          </div>
          <div>
            You'll get a verification code via SMS to <b>{{ reserveAuthSettings?.phone }}</b>
          </div>
        </div>
        @if (step < ReserveAuthSteps.SendEmailCode) {
          <mbs-button
            [disabled]="step !== ReserveAuthSteps.SendPhoneCode"
            [loading]="stepLoading === ReserveAuthSteps.SendPhoneCode && step === ReserveAuthSteps.SendPhoneCode"
            (click)="sendSMS()"
            class="mr-2"
            >Get code
          </mbs-button>
        } @else {
          <mbs-alert
            [type]="MbsPopupType.success"
            [icon]="true"
            class="confirmed-alert m-0"
            >Confirmed</mbs-alert
          >
        }
      </div>

      <div
        *ngIf="step === ReserveAuthSteps.ConfirmPhoneCode"
        class="d-flex align-items-end justify-content-between mt-3">
        <mbs-input
          formControlName="phoneCode"
          class="w-100"
          (keyup.enter)="confirmPhone()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [boldLabel]="true"
          [label]="'Verification code'"
          [placeholder]="'shared:placeholders.enterTheCodeFromTheSMS' | i18next"></mbs-input>
        <mbs-button
          class="ml-2"
          type="primary"
          (click)="confirmPhone()"
          [disabled]="form.controls.phoneCode.invalid"
          [loading]="stepLoading === ReserveAuthSteps.ConfirmPhoneCode"
          >Confirm</mbs-button
        >
      </div>

      <mbs-input-errors [errors]="$any(form.controls.phoneCode.errors)"></mbs-input-errors>

      <mbs-reserve-auth-resend-code-button
        class="mt-2"
        *ngIf="step === ReserveAuthSteps.ConfirmPhoneCode"
        (onResend)="sendSMS()"
        [loading]="stepLoading === ReserveAuthSteps.SendPhoneCode"
        [seconds]="secondsToResend"></mbs-reserve-auth-resend-code-button>
    </ng-container>
  </mbs-step>
  <mbs-step
    [number]="2"
    [readOnly]="true"
    [isSimple]="true">
    <ng-container body>
      <div class="d-flex align-items-end justify-content-between">
        <div
          class="mr-2"
          [ngClass]="{ 'text-disabled': step !== ReserveAuthSteps.SendEmailCode }">
          <div
            class="fw-bold mbs-form_label"
            [ngClass]="{ 'text-disabled': step !== ReserveAuthSteps.SendEmailCode }">
            Email verification
          </div>
          <div>
            You'll get a verification code to <b>{{ reserveAuthSettings?.email }}</b>
          </div>
        </div>
        @if (step <= ReserveAuthSteps.ConfirmEmailCode) {
          <mbs-button
            (click)="sendEmail()"
            [disabled]="step !== ReserveAuthSteps.SendEmailCode"
            [loading]="stepLoading === ReserveAuthSteps.SendEmailCode && step === ReserveAuthSteps.SendEmailCode"
            class="mr-2"
            >Get code
          </mbs-button>
        } @else {
          <mbs-alert
            [type]="MbsPopupType.success"
            [icon]="true"
            class="confirmed-alert m-0"
            >Confirmed</mbs-alert
          >
        }
      </div>

      <div
        *ngIf="step === ReserveAuthSteps.ConfirmEmailCode"
        class="d-flex align-items-end justify-content-between mt-3">
        <mbs-input
          formControlName="emailCode"
          class="w-100"
          (keyup.enter)="confirmEmail()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [boldLabel]="true"
          [label]="'Verification code'"
          [placeholder]="'shared:placeholders.enterTheCodeFromTheEmail' | i18next"></mbs-input>
        <mbs-button
          class="ml-2"
          type="primary"
          (click)="confirmEmail()"
          [disabled]="form.controls.emailCode.invalid"
          [loading]="stepLoading === ReserveAuthSteps.ConfirmEmailCode"
          >Confirm</mbs-button
        >
      </div>

      <mbs-input-errors [errors]="$any(form.controls.emailCode.errors)"></mbs-input-errors>

      <mbs-reserve-auth-resend-code-button
        class="mt-2"
        *ngIf="step === ReserveAuthSteps.ConfirmEmailCode"
        (onResend)="sendEmail()"
        [loading]="stepLoading === ReserveAuthSteps.SendEmailCode"
        [seconds]="secondsToResend"></mbs-reserve-auth-resend-code-button>
    </ng-container>
  </mbs-step>
</mbs-steps>
